import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import * as Showdown from 'showdown';

@Component({
  selector: 'app-show-version',
  templateUrl: './show-version.component.html',
  styleUrls: ['./show-version.component.sass']
})
export class ShowVersionComponent implements OnInit {
  // We'll store the final HTML here
  htmlContent: SafeHtml | undefined;

  constructor(
    private readonly http: HttpClient,
    private readonly sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    // Fetch your local .md file from assets
    this.http.get('assets/CHANGELOG.MD', { responseType: 'text' })
      .subscribe({
        next: markdown => {
          // Create the Showdown converter
          const converter = new Showdown.Converter();

          // Convert to HTML
          const rawHtml = converter.makeHtml(markdown);

          // Angular sanitizes HTML by default. Bypass carefully if you trust the source:
          this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(rawHtml);
        },
        error: err => {
          console.error('Error fetching Markdown file:', err);
        }
      });
  }
}
